/* CARSTN - Top Tracks
   Fetches live Spotify top tracks from the feeds worker and replaces the static
   fallback list. If no worker URL is set, or the fetch fails, the fallback stays. */
(function () {
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  // Punctuation is stripped first so "Faded (CARSTN Remix)" reads FC, not "F(".
  // Range covers latin + accented letters and digits; avoids \p{...} so the file
  // still parses in older mobile browsers.
  function initials(s) {
    return String(s || "")
      .replace(/[^0-9A-Za-zÀ-ɏ\s]/g, " ")
      .trim()
      .split(/\s+/)
      .map(function (w) { return w.charAt(0); })
      .join("")
      .slice(0, 2)
      .toUpperCase();
  }

  document.querySelectorAll(".tracks-section[data-worker-url]").forEach(function (section) {
    var worker = (section.getAttribute("data-worker-url") || "").trim().replace(/\/+$/, "");
    if (!worker) return; // keep the static fallback
    var artist = section.getAttribute("data-artist-id") || "";
    var count = parseInt(section.getAttribute("data-count") || "5", 10) || 5;
    var list = section.querySelector(".tracks");
    if (!list) return;

    fetch(worker + "/top-tracks?artist=" + encodeURIComponent(artist) + "&count=" + count + "&market=DE", {
      credentials: "omit",
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.tracks) || !data.tracks.length) return;
        list.innerHTML = data.tracks
          .slice(0, count)
          .map(function (t, i) {
            var rank = ("0" + (i + 1)).slice(-2);
            var cover = t.cover
              ? '<div class="track__cover"><img src="' + esc(t.cover) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover"></div>'
              : '<div class="track__cover">' + esc(initials(t.name)) + "</div>";
            var play = t.external_url
              ? '<a href="' + esc(t.external_url) +
                '" class="track__play" target="_blank" rel="noopener" aria-label="Play ' +
                esc(t.name) + '">▶</a>'
              : '<span class="track__play" aria-hidden="true">▶</span>';
            return (
              '<li class="track">' +
              '<span class="track__rank">' + rank + "</span>" +
              cover +
              "<div><h3 class=\"track__title\">" + esc(t.name) + "</h3>" +
              (t.album && t.album !== t.name ? '<div class="track__meta">' + esc(t.album) + "</div>" : "") + "</div>" +
              '<div class="track__plays">' + esc(t.year || "") + "</div>" +
              play +
              "</li>"
            );
          })
          .join("");
        list.setAttribute("data-state", "ready");
      })
      .catch(function () { /* keep the fallback */ });
  });
})();
